import Vue from 'vue'
import App from '@/App.vue'
import router from '@/routes'
import store from '@/store'
import i18n from '@/i18n'
import { axios } from '@/api'
import '@/assets/css/index.scss'

Vue.config.productionTip = false

Vue.prototype.$axios = axios

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
